<template>
  <div>
    <el-select
      :value="value"
      size="small"
      clearable
      @change="handleChange"
      placeholder="请选择物流公司"
      style="width: 100%"
      :popper-append-to-body="false"
    >
      <el-option
        v-for="(k, v) in lists"
        :key="v"
        :label="k"
        :value="v"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { getShippers } from '@/service/getData'

export default {
  props: {
    value: '',
  },
  data() {
    return {
      lists: {},
    }
  },

  created() {
    this.getList()
  },
  methods: {
    async getList() {
      let res = await getShippers()
      if (res.status == 0) {
        this.lists = res.data
      }
    },
    handleChange(e) {
      this.$emit('input', e)
    },
  },
}
</script>
<style>
.select-err .el-input__inner {
  border-color: #f56c6c;
}
</style>